import React from 'react';
import { FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';

/**
 * Reusable Chat Toggle Button Component
 * @param {Object} props - Component props
 * @param {boolean} props.isChatVisible - Whether chat is visible
 * @param {function} props.onToggle - Toggle callback function
 * @param {number} props.iconSize - Icon size (default: 18)
 */
const ChatToggleButton = React.memo(({ isChatVisible, onToggle, iconSize = 18 }) => {
  return (
    <button
      onClick={onToggle}
      title={isChatVisible ? "Hide Chat Panel" : "Show Chat Panel"}
      aria-label={isChatVisible ? "Hide Chat Panel" : "Show Chat Panel"}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        height: '35px',
        padding: '0 12px',
        backgroundColor: isChatVisible ? '#ffffff' : '#f0f9ff',
        borderRadius: '8px',
        border: isChatVisible ? '1px solid #e2e8f0' : '1px solid #bae6fd',
        fontSize: '13px',
        fontWeight: '500',
        color: isChatVisible ? '#64748b' : '#0284c7',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = isChatVisible ? '#f8fafc' : '#e0f2fe';
        e.currentTarget.style.borderColor = isChatVisible ? '#cbd5e1' : '#38bdf8';
        e.currentTarget.style.color = isChatVisible ? '#475569' : '#0369a1';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = isChatVisible ? '#ffffff' : '#f0f9ff';
        e.currentTarget.style.borderColor = isChatVisible ? '#e2e8f0' : '#bae6fd';
        e.currentTarget.style.color = isChatVisible ? '#64748b' : '#0284c7';
      }}
    >
      {isChatVisible ? (
        <FiChevronsLeft size={iconSize} />
      ) : (
        <FiChevronsRight size={iconSize} />
      )}
    </button>
  );
});

ChatToggleButton.displayName = 'ChatToggleButton';

export default ChatToggleButton;

